import { Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import Button from "../../shared/Button";
import CounterWithlabelin from "../../shared/CounterWithlabelin";
import Selectbox from "../../shared/Select";
import Textarea from "../../shared/Textarea";

const CreateStep7 = ({ prevStep, nextStep }) => {
  const { updatePlaceDetail, createInfoData,apiUpdateResideces ,setIsEditPlaceCompleter} = useCreatePlace();

  const faselezamani = [
    {
      value: 1,
      label: 1
    },
    {
      value: 2,
      label: 2
    },
    {
      value: 3,
      label: 3
    },
    {
      value: 4,
      label: 4
    },
    {
      value: 5,
      label: 5
    },
    {
      value: 6,
      label: 6
    },
    {
      value: 7,
      label: 7
    },
    {
      value: 8,
      label: 8
    },
    {
      value: 9,
      label: 9
    },
    {
      value: 10,
      label: 10
    },
    {
      value: 11,
      label: 11
    },
    {
      value: 12,
      label: 12
    },
    {
      value: 13,
      label: 13
    },
    {
      value: 14,
      label: 14
    },
    {
      value: 15,
      label: 15
    },
    {
      value: 16,
      label: 16
    },
    {
      value: 17,
      label: 17
    },
    {
      value: 18,
      label: 18
    },
    {
      value: 19,
      label: 19
    },
    {
      value: 20,
      label: 20
    },
    {
      value: 21,
      label: 21
    },
    {
      value: 22,
      label: 22
    },
    {
      value: 23,
      label: 23
    },
    {
      value: 24,
      label: 24
    }
  ];
  const [entrance_time, setentrance_time] = useState(
    createInfoData.stepNine.entrance_time
  );
  const [to_entrance_time, setto_entrance_time] = useState(
    createInfoData.stepNine.to_entrance_time
  );
  const [min_stay, setmin_stay] = useState(createInfoData.stepNine.min_stay);
  const [max_stay, setmax_stay] = useState(createInfoData.stepNine.max_stay);
  const [pet_check_in, setpet_check_in] = useState(
    createInfoData.stepNine.pet_check_in
  );
  const [smoking, setsmoking] = useState(createInfoData.stepNine.smoking);
  const [single, setsingle] = useState(createInfoData.stepNine.single);
  const [party, setparty] = useState(createInfoData.stepNine.party);
  const [leaving_time, setleaving_time] = useState(
    createInfoData.stepNine.leaving_time
  );
  const [ToEntError, setToEntError] = useState("");
  const [ToExittError, setToExittError] = useState("");
  const [MinError, setMinError] = useState("");
  useEffect(() => {
    setentrance_time(createInfoData.stepNine.entrance_time)
    setto_entrance_time(createInfoData.stepNine.to_entrance_time)
    setmin_stay(createInfoData.stepNine.min_stay)
    setmax_stay(createInfoData.stepNine.max_stay)
    setpet_check_in(createInfoData.stepNine.pet_check_in)
    setsmoking(createInfoData.stepNine.smoking)
    setsingle(createInfoData.stepNine.single)
    setparty(createInfoData.stepNine.party)
    setleaving_time(createInfoData.stepNine.leaving_time)
  }, [createInfoData])
  
  const onSubmit = data => {
    if (entrance_time === null) {
      setToEntError("ساعت ورود اجباری است");
      window.screenTop(0,0)
    } else if (leaving_time === null) {
      setToExittError("ساعت خروج از اقامتگاه اجباری است.");
      window.scrollTo(0,0)

    } else if( max_stay <= min_stay){
      setMinError("حداکثر مدت  اقامت باید بزرگتر از حداقل مدت اقامت باشد.")
       
    }else {
      setMinError("")
      setToExittError("")
      setToEntError("")
      updatePlaceDetail("stepNine", {
        entrance_time: entrance_time,
        leaving_time: leaving_time,
        min_stay: min_stay,
        max_stay: max_stay,
        pet_check_in: pet_check_in,
        smoking: smoking,
        single: single,
        party: party
      });
      nextStep();
    }
  };
  const {id}=useParams()
  console.log("party",party)

  const { formState: { errors, isValid }, control, handleSubmit } = useForm();
  const update = (data) => {
    if (entrance_time === null) {
      setToEntError("ساعت ورود اجباری است");
      window.screenTop(0,0)
    } else if (leaving_time === null) {
      setToExittError("ساعت خروج از اقامتگاه اجباری است.");
      window.scrollTo(0,0)

    } else if( max_stay <= min_stay){
      setMinError("حداکثر مدت  اقامت باید بزرگتر از حداقل مدت اقامت باشد.")
       
    }else {
      setMinError("")
      setToExittError("")
      setToEntError("")
      updatePlaceDetail("stepNine", {
        entrance_time: entrance_time,
        leaving_time: leaving_time,
        min_stay: min_stay,
        max_stay: max_stay,
        pet_check_in: pet_check_in,
        smoking: smoking,
        single: single,
        party: party
      });
       setIsEditPlaceCompleter(true);
    
      }
  };
  return (
    <div className="createsteps">
      {" "}<h2>قوانین رزرو</h2>
      <p className="w-[100%] ">
        شرایط و قوانین پذیرش مهمان از فرایند ثبت درخواست تا تحویل اقامتگاه به
        مهمان را تعیین کنید .
      </p>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        ساعت ورود و خروج
      </h4>
      <p className="w-[100%] ">
        بازه ای که شما یا کلید دار برای تحویل اقامتگاه به مهمان در دسترس خواهید
        بود و همچنین حداکثر ساعتی که مهمان موظف و تخلیه اقامتگاه می باشد
      </p>
      <div className="createsteps--grid3 mt-[50px]">
        <div>
          <Selectbox
            label="از ساعت"
            placeholder="تعیین کنید"
            option={faselezamani}
            value={entrance_time}
            onChange={value => setentrance_time(value)}
          />
          <span className="input__message text-red mt-[4px]">
            {ToEntError}
          </span>
        </div>

        <Selectbox
          label="تا ( اختیاری )"
          placeholder="تعیین کنید"
          option={faselezamani}
          value={to_entrance_time}
          onChange={value => setto_entrance_time(value)}
        />
       <div>
       <Selectbox
          label="ساعت خروج"
          placeholder="تعیین کنید"
          option={faselezamani}
          value={leaving_time}
          onChange={value => setleaving_time(value)}
        />
         <span className="input__message text-red mt-[4px]">
            {ToExittError}
          </span>
       </div>
      </div>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        حداقل مدت اقامت
      </h4>
      <p className="w-[100%] ">
        حداقل تعداد شب هایی که مهمان می تواند اقامتگاه شما رزرو کند{" "}
      </p>
      <div className="grid md:grid-cols-3 grid-cols-2 gap-[16px] mt-[50px]">
        <CounterWithlabelin
          count={min_stay}
          setCount={setmin_stay}
          label="حداقل مدت اقامت"
          labelin="روز"
        />
      </div>
      <div>
      <div className="grid md:grid-cols-3 grid-cols-2 gap-[16px] mt-[50px]">
        <CounterWithlabelin
          count={max_stay}
          setCount={setmax_stay}
          label="حداکثر مدت اقامت"
          labelin="روز"
        />
      </div>
      <span className="input__message text-red mt-[4px]">
            {MinError}
          </span>
      </div>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        مقررات اقامتگاه
      </h4>
      <p className="w-[100%] ">
        قوانین و مقررات خود را برای پذیرش مهمان ها را اعلام کنید
      </p>
      <div className="grid grid-cols-2 gap-[50px]">
        <div className="primary-checkbox">
          <h6 className="text-[#292D32] text-[20px] text-[700] mb-[8px]">
            ورود حیوان خانگی (اختیاری)
          </h6>
          <Checkbox
            value={pet_check_in}
            defaultChecked={pet_check_in}
            onClick={e => setpet_check_in(e.target.value)}
          >
          ورود حیوان خانگی مجاز می باشد.
          </Checkbox>
        </div>
        <div className="primary-checkbox">
          <h6 className="text-[#292D32] text-[20px] text-[700] mb-[8px]">
            برگذاری مهمانی و مجالس (اختیاری)
          </h6>

          <Checkbox
            value={party}
            defaultChecked={party}
            onClick={e => setsmoking(e.target.value)}
          >
           بارگذاری مهمانی و مجالس در این اقامتگاه مانعی ندارد.
          </Checkbox>
        </div>
        <div className="primary-checkbox">
          <h6 className="text-[#292D32] text-[20px] text-[700] mb-[8px]">
            استعمال دخانیات (اختیاری)
          </h6>

          <Checkbox
            value={single}
            defaultChecked={single}
            onClick={e => setsingle(e.target.value)}
          >
            استعمال دخانیات در این اقامتگاه مانعی ندارد.
          </Checkbox>
        </div>
        <div className="primary-checkbox">
          <h6 className="text-[#292D32] text-[20px] text-[700] mb-[8px]">
            گروه مجرد (اختیاری)
          </h6>

          <Checkbox
            value={party}
            defaultChecked={party}
            onClick={e => setparty(e.target.value)}
          >
            این اقامتگاه پذیرای گروه های مجردی می باشد
          </Checkbox>
        </div>
      </div>
      <form >
        {" "}<Textarea
          name="des"
          control={control}
          errors={errors}
          className="seconadary-input mt-[50px]"
          rows="5"
          label="توضیحات تکمیلی ( اختیاری )"
          placeholder="توضیحات تکمیلی راجب قوانین اقامتاگاه را وارد نمایید"
        />
        <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
      { id && <Button varient="primary"  onClick={handleSubmit((d) =>update(d))}> 
                بروزرسانی اقامتگاه
              </Button>}
          <Button
            varient="gray"
            onClick={() => {
              prevStep();
            }}
          >
            مرحله قبلی
          </Button>

          <Button onClick={handleSubmit((d) =>onSubmit(d))} varient="primary" type="submit">
            مرحله بعدی
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateStep7;

//   const most = [
//     {

//         value:"بدون محدودیت",
//         label:"بدون محدودیت"
//     },
//     {

//        value:"یک هفته",
//        label:" یک هفته"
//    },
//    {

//     value:"دو هفته",
//     label:" دو هفته"
// },
// {

//     value:"سه هفته",
//     label:" سه هفته"
// },
// {

//     value:"یک ماه",
//     label:" یک ماه"
// },
// {

//     value:"سه ماه",
//     label:" سه ماه"
// },
// {

//     value:"شش ماه",
//     label:" شش ماه"
// },
// ]
